var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"c-icon c-icon--arrow",style:(_vm.style)},[_c('svg',[_c('use',{attrs:{"xlink:href":"#arrow-left"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }